export default "__VITE_ASSET__DDWkr6DD__"